import validator from 'validator';

export const isNotEmpty = value => (value && !validator.isEmpty(value + '') ? undefined : 'Darf nicht leer sein!')